export default __webpack_public_path__ + "locales/lo-LA/VersionHistory.json?hash=4b1aef8f60bf224ec272a12e81934c2e";